import { getVariant } from "@api/completion";
import { SITE_PRIMARY_COLOR } from "@api/constants";
import CourseCompletion, { Attribute } from "@api/types/course-completion";
import { FC } from "react";

function getAttribute(attributes: Attribute[], attributeCode: string) {
  if (!attributes) {
    return "";
  }

  let returnAttribute = attributes.find((a) => a.code === attributeCode);
  return returnAttribute ? returnAttribute.value : "";
}

const EnrolledCourseDetails: FC<{ completion: CourseCompletion }> = ({ completion }) => {
  const { courseObject } = completion;
  const description =
    courseObject.description && courseObject.description.length > 0
      ? courseObject.description
      : getAttribute(completion?.product?.attributes, "longdescription");
  const variant = getVariant(completion);

  return (
    <>
      <div className="EnrolledCourseDetails">
        <h2>{variant ? `${courseObject.courseName} (${variant})` : courseObject.courseName}</h2>
        <div
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </div>
      {/* language=CSS */}
      <style jsx>
        {`
          h2 {
            margin: 16px 0;
            font-size: 24px;
            font-weight: 500;
            color: ${SITE_PRIMARY_COLOR};
          }
        `}
      </style>
    </>
  );
};

export default EnrolledCourseDetails;
